// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-layout {
  display: flex;
  min-height: 100vh;
  background: #f5f5f5;
}

.dashboard-sidebar {
  width: 220px;
  background: #222e3c;
  color: #fff;
  padding: 32px 0 0 0;
  min-height: 100vh;
  box-shadow: 2px 0 8px rgba(0,0,0,0.04);
}

.sidebar-title {
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 32px;
}

.dashboard-sidebar nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.dashboard-sidebar nav li {
  padding: 16px 32px;
  font-size: 16px;
  cursor: pointer;
  background: none;
  border: none;
  color: #fff;
  transition: background 0.2s;
}

.dashboard-sidebar nav li.active,
.dashboard-sidebar nav li:hover {
  background: #1a2230;
}

.dashboard-content {
  flex: 1 1;
  padding: 40px 48px;
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  margin-top: 24px;
}

.orders-table th, .orders-table td {
  padding: 14px 18px;
  border-bottom: 1px solid #eee;
  text-align: left;
}

.orders-table th {
  background: #f0f4f8;
  font-weight: bold;
}

.orders-table tr:last-child td {
  border-bottom: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".dashboard-layout {\n  display: flex;\n  min-height: 100vh;\n  background: #f5f5f5;\n}\n\n.dashboard-sidebar {\n  width: 220px;\n  background: #222e3c;\n  color: #fff;\n  padding: 32px 0 0 0;\n  min-height: 100vh;\n  box-shadow: 2px 0 8px rgba(0,0,0,0.04);\n}\n\n.sidebar-title {\n  font-size: 22px;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.dashboard-sidebar nav ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.dashboard-sidebar nav li {\n  padding: 16px 32px;\n  font-size: 16px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  color: #fff;\n  transition: background 0.2s;\n}\n\n.dashboard-sidebar nav li.active,\n.dashboard-sidebar nav li:hover {\n  background: #1a2230;\n}\n\n.dashboard-content {\n  flex: 1;\n  padding: 40px 48px;\n}\n\n.orders-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.04);\n  margin-top: 24px;\n}\n\n.orders-table th, .orders-table td {\n  padding: 14px 18px;\n  border-bottom: 1px solid #eee;\n  text-align: left;\n}\n\n.orders-table th {\n  background: #f0f4f8;\n  font-weight: bold;\n}\n\n.orders-table tr:last-child td {\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
